module.exports = __webpack_public_path__ + "img/dead-grey-trunk-01.9ea042d5.png";